import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import AttachList from "customerAttachments/components/AttachmentList"
import { AttachmentErrorMapping, AttachmentStatusMapping, PurchaseAttachMapping } from "customerAttachments/constants"
import { PurchaseAttachmentType } from "customerAttachments/types"

import useGetPurchaseAttachList from "./hooks/useGetPurchaseAttachList"

const PurchaseAttachList = () => {
  const { orderNo = "" } = useParams<{ orderNo: string }>()
  const { data, isLoading } = useGetPurchaseAttachList(orderNo)
  const { t } = useTranslation("sales")

  const isValidErrorKey = (key: number): key is keyof typeof AttachmentErrorMapping => {
    return key in AttachmentErrorMapping
  }

  const attachments =
    data?.map((item: PurchaseAttachmentType) => {
      const targetItem = PurchaseAttachMapping[item.AttachType as keyof typeof PurchaseAttachMapping] || {}
      const statusText = AttachmentStatusMapping[item.Status as keyof typeof AttachmentStatusMapping] || ""
      const isDisabled = ["UnderReview", "UploadNotYetAvailable"].includes(item.Status)
      const errorText =
        item.Note?.RejectReasonType && isValidErrorKey(Number(item.Note?.RejectReasonType))
          ? AttachmentErrorMapping[Number(item.Note.RejectReasonType) as keyof typeof AttachmentErrorMapping]
          : ""

      return {
        ...item,
        ...targetItem,
        Text: `${targetItem.Text}${!!item.Note?.Vin ? ` (${t("customer_attachments.vin")}：${item.Note?.Vin})` : ""}`,
        Status: statusText,
        IsDisabled: isDisabled,
        ErrorText: errorText,
      }
    }) ?? []

  return <AttachList data={attachments} orderType="purchase" isLoading={isLoading} />
}

export default PurchaseAttachList
